import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHouseFloor = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14 20.9998V14.9998H10V20.9998M19 9.77794V16.1998C19 17.88 19 18.7201 18.673 19.3618C18.3854 19.9263 17.9265 20.3852 17.362 20.6729C16.7202 20.9998 15.8802 20.9998 14.2 20.9998H9.8C8.11984 20.9998 7.27976 20.9998 6.63803 20.6729C6.07354 20.3852 5.6146 19.9263 5.32698 19.3618C5 18.7201 5 17.88 5 16.1998V9.77728M21 11.9998L15.5668 5.96381C14.3311 4.59104 13.7133 3.90466 12.9856 3.65126C12.3466 3.4287 11.651 3.42875 11.0119 3.65141C10.2843 3.90491 9.66661 4.59139 8.43114 5.96433L3 11.9998",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgHouseFloor;
